import React from 'react';
import './Table.css';
import './TableSZ-custom.css';
import Chip from '../chips/Chips';
import { Overlay, OverlayTrigger, Tooltip } from 'react-bootstrap';
import bets from '../betmap_OLD.json';

 

class RouletteTable extends React.Component {


  componentDidMount() {
    // Add class to body when component mounts
    document.body.classList.add('roulette-active');
  }

  constructor(props) {
    super(props);

    this.state = {
      firstRow: props.firstRow || [],
      firstBorder: props.firstBorder || [],
      secondRow: props.secondRow || [],
      secondBorder: props.secondBorder || [],
      thirdRow: props.thirdRow || [],
      thirdBorder: props.thirdBorder || [],
      fourthRow: props.fourthRow || [],
      fifthRow: props.fifthRow || [],
      columnLeft: props.columnLeft || [],
      columnRight: props.columnRight || [],
      disabled: false,
      betDenomination: 0, // Default denomination is 0
      selectedBets: {},   // Stores placed bets
      betsMap: {}, // Tracks placed bets for each number
      betsTotal: 0,
      betsInfoTxt: 'ON', 
      hoveredValue: '',
    };

    // Привязываем методы к this
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }


  updateBetsInfoTxt = (text) => {
    this.setState({betsInfoTxt: text});
  }


  // handleChipClick = (betKey) => {
  //   const bet = bets[betKey]; // Fetch bet details from betmap.json
  //   console.log(bet);
  //   if (!bet) return;
    
  //   const numberKey = betKey; // bet.numbers[0]; // Get the number associated with the bet
  //   const denomination = this.state.betDenomination; // Current selected denomination
  
  //   // if (denomination <= 0) {
  //   //   alert("Please select a denomination before placing a bet!");
  //   //   return;
  //   // }

  //   // Update the bets map in the state
  //   this.setState((prevState) => {
  //     const updatedBetsMap = { ...prevState.betsMap };
  
  //     // Add to existing bet or create new bet
  //     updatedBetsMap[numberKey] = (updatedBetsMap[numberKey] || 0) + denomination;
  
  //     const betsTotal = this.calculateBetsTotal(updatedBetsMap);

  //     // alert(
  //     //   `Bet Placed!\n` +
  //     //   `Key: ${betKey}\n` +
  //     //   `Numbers: ${bet.numbers.join(', ')}\n` +
  //     //   `Payout: ${bet.payout}\n` +
  //     //   `Total Bet Amount: ${updatedBetsMap[numberKey]}`
  //     // );

 
  //     this.props.onDataUpdate({betsMap: updatedBetsMap});
  
  //     return { betsMap: updatedBetsMap, betsTotal: betsTotal };
  //   });
  // };

  onSetDenomination = (value) => {
    this.setState({ betDenomination: value });
  };

  disableTable = () => {	
    if (this.props.spinning) {	
      this.setState({ disabled: true });	
    } else {	
      this.setState({ disabled: false });	
    }	
  }

  // SELECTING BETS
  numsSelectionHandler = (num, whichRow) => {

    let nums = this.props.arr.length === 0 ? [] : [...this.props.arr];
    console.log(nums);

    let row = [...this.state[whichRow]];

    let coins;


  
 
    if (nums.indexOf(num) >= 0) {
      nums.splice(nums.indexOf(num), 1);
      coins = this.props.coins + this.props.chip;
  

      let updatedRow = row.map(chip => {
        if (chip.n === num) {
          chip.visible = false;
 
        }
        return chip;
      });
  
      this.props.updateRow(whichRow, updatedRow);
      this.setState({ [whichRow]: updatedRow });
    } 

    else {
      coins = this.props.coins - this.props.chip;
      nums.push(num);
  
   
      let updatedRow = row.map(chip => {
        if (chip.n === num) {
          chip.visible = true;

        }
        return chip;
      });
  
      this.setState({ [whichRow]: updatedRow });
    }
  

    this.props.updateCoins(coins);
  };


  handleMouseEnter = (num, whichRow) => {
    let row = [...this.state[whichRow]];
    let nums = this.props.arr.length === 0 ? [] : [...this.props.arr];
    let updatedRow = row.map(chip => {
      if (chip.n === num) {
        chip.hover = true;
      }
      return chip;
    });

    if (nums.indexOf(num) >= 0) {
      nums.splice(nums.indexOf(num), 1);
      // coins = this.props.coins + this.props.chip;
  

      let updatedRow = row.map(chip => {
        if (chip.n === num) {
          chip.visible = false;
 
        }
        return chip;
      });
  
      this.props.updateRow(whichRow, updatedRow);
      this.setState({ [whichRow]: updatedRow });
    } 

    this.setState({ [whichRow]: updatedRow });
    console.log(nums); 
  };
  
  handleMouseLeave = (num, whichRow) => {
    let row = [...this.state[whichRow]];
    let updatedRow = row.map(chip => {
      if (chip.n === num) {
        chip.hover = false;
      }
      return chip;
    });
  
    this.setState({ [whichRow]: updatedRow });
  };

  onClearTable = () => {
    this.setState({betsMap: {}, betsTotal: 0});
  }

  calculateBetsTotal = (betsMap) => {
    const initialValue = 0;
    const betsTotal = Object.values(betsMap).reduce(
      (accumulator, currentValue) => accumulator + (!currentValue ? 0 : currentValue),
      initialValue,
    );
    return betsTotal;
  }

  onSetDenomination = (value) => {
    // Update the state
    this.setState({ betDenomination: value });

    // Update the cursor for the body
    const body = document.body;
    body.classList.remove('cursor-blue', 'cursor-green', 'cursor-red', 'cursor-purple', 'cursor-yellow', 'cursor-black');
    switch (value) {
      case 1:
        body.classList.add('cursor-yellow');
        break;
      case 5:
        body.classList.add('cursor-blue');
        break;
      case 10:
        body.classList.add('cursor-green');
        break;
      case 20:
        body.classList.add('cursor-purple');
        break;
      case 50:
        body.classList.add('cursor-black');
        break;
      case 100:
        body.classList.add('cursor-orange');
        break;
      default:
        break;
    }
  };


  handleChipClick = (betKey) => {
    const bet = bets[betKey]; // Fetch bet details from betmap.json
    // console.log(bet.numbers);
    if (!bet) return;
    
    const numberKey = betKey; // bet.numbers[0]; // Get the number associated with the bet
    const denomination = this.props.betDenomination; // Current selected denomination
  
    // if (denomination <= 0) {
    //   alert("Please select a denomination before placing a bet!");
    //   return;
    // }

    const BETS_LIST_OUTSIDE = ['BLACK', 'RED', 'ODD', 'EVEN', 'HIGH', 'LOW', 'COLUMN1', 'COLUMN2', 'COLUMN3', 'DOZEN1', 'DOZEN2', 'DOZEN3', 'ZEROSPIEL', 'ORPHELINS', 'VOISINS', 'REDSPLIT', 'BLACKSPLIT', 'TIERS', 'SNAKE']

    // Restrict bet on a single number 2000
    const MAX_BET_FOR_NUMBER = BETS_LIST_OUTSIDE.includes(numberKey) ? 5000 : 2000;
    if (denomination > MAX_BET_FOR_NUMBER) {
      return;
    }

    const prevBetMap = this.state.betsMap;
    // const restrictedList = ['SINGLE', 'SPLIT', 'STREET', 'FIRSTFOUR', 'CORNER', 'SIXLINE'];
    const nextVal = prevBetMap[numberKey] + denomination;
    // for (const betType of restrictedList) {
    //   if (prevBetMap[numberKey] && nextVal > MAX_BET_FOR_NUMBER && numberKey.includes(betType)) {
    //     return;
    //   }
    // }

    if (prevBetMap[numberKey] && nextVal > MAX_BET_FOR_NUMBER) {
      return;
    }

    // Update the bets map in the state
    this.setState((prevState) => {
      const updatedBetsMap = { ...prevState.betsMap };
  
      // Add to existing bet or create new bet
      updatedBetsMap[numberKey] = (updatedBetsMap[numberKey] || 0) + denomination;
  
      const betsTotal = this.calculateBetsTotal(updatedBetsMap);
      const MAX_BETS_SUM = 30000;
      if (betsTotal > MAX_BETS_SUM) {
        return;
      }
      // console.log(betsTotal);

      // alert(
      //   `Bet Placed!\n` +
      //   `Key: ${betKey}\n` +
      //   `Numbers: ${bet.numbers.join(', ')}\n` +
      //   `Payout: ${bet.payout}\n` +
      //   `Total Bet Amount: ${updatedBetsMap[numberKey]}`
      // );
 
      this.props.onDataUpdate({betsMap: updatedBetsMap, betsTotal: betsTotal});
  
      return { betsMap: updatedBetsMap, betsTotal: betsTotal };
    });

  };

  handleMouseEnterChip = (val) => {
    const bet = bets[val];

    if (bet && Array.isArray(bet.numbers)) {
        const numbersString = bet.numbers.join(",");  
        this.setState({ hoveredValue: numbersString });
    } else {
      this.setState({ hoveredValue: '' });
    }
  };
  
  handleMouseLeaveChip = () => {
    this.setState({ hoveredValue: '' });
  };




  render() {
    return (
      <React.Fragment>
        <div className="d-flex flex-row align-items-start roulette-table">
          {/* LEFT COLUMN (Tiers top, Zero below) */}
          <div className="align-self-start">
            <ul className="list-unstyled">
              <li className="left-extra-block tiers-block-custom blues cella chip-container-cella">
                <button className="blues" onClick={() => this.handleChipClick("TIERS")}
                  onMouseEnter={() => this.handleMouseEnterChip("TIERS")}
                  onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div>Tiers</div>
                  <div className="chip-number chipt-number-right"
                    style={{ display: this.state.betsMap['TIERS'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['TIERS'] || ''}</div>
                </button>
              </li>
              <li className={`greens cella-z-bottom chip-container-cella-z pentagon-border single-zero ${this.state.hoveredValue.split(/[,\s-]+/).includes('0') ? 'hovered-class' : ''}`}  value="0"
                onClick={() => this.handleChipClick("SINGLE37")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE37")}
                onMouseLeave={this.handleMouseLeaveChip}
              >
                <span className=" pentagon"  
                
                >0
                  <div className="chip-number chipt-number-zero"
                      style={{ display: this.state.betsMap['SINGLE37'] ? 'flex' : 'none' }}
                    >{this.state.betsMap['SINGLE37'] || ''}
                  </div>
                </span>
              </li>
              <li className="left-extra-block tiers-block-custom reds cella chip-container-cella">
                <button className="reds" onClick={() => this.handleChipClick("REDSPLIT")}
                  onMouseEnter={() => this.handleMouseEnterChip("REDSPLIT")}
                  onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="red-blck-split-txt">red split</div>
                  <div className="chip-number chipt-number-right"
                    style={{ display: this.state.betsMap['REDSPLIT'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['REDSPLIT'] || ''}</div>
                </button>
              </li>
            </ul>
          </div>

    

          {/* MAIN TABLE */}
          <div className="align-self-start home-middle"> 

          <div className="home-table">
            <div className="chip-hi">
              <div className="chip-item">
                <div className="chip-pos chip-top-left" onClick={() => this.handleChipClick("FIRSTFOUR")}
                onMouseEnter={() => this.handleMouseEnterChip("FIRSTFOUR")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-left"
                    style={{ display: this.state.betsMap['FIRSTFOUR'] ? 'none' : 'none' }}
                    
                    >{this.state.betsMap['FIRSTFOUR'] || ''}</div>
                </div>
                <div className="chip-pos chip-top-center" onClick={() => this.handleChipClick("STREET3")}
                  onMouseEnter={() => this.handleMouseEnterChip("STREET3")}
                  onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-center"
                    style={{ display: this.state.betsMap['STREET3'] ? 'none' : 'none' }}
                  >{this.state.betsMap['STREET3'] || ''}</div>
                </div>
                <div className="chip-pos chip-top-right" onClick={() => this.handleChipClick("SIXLINE1")}
                  onMouseEnter={() => this.handleMouseEnterChip("SIXLINE1")}
                  onMouseLeave={this.handleMouseLeaveChip}
                >
                 <div className="chip-number chip-number-top-right"
                    style={{ display: this.state.betsMap['SIXLINE1'] ? 'none' : 'none' }}
                   >{this.state.betsMap['SIXLINE1'] || ''} 
                 </div>
                </div>
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT10")}
                  onMouseEnter={() => this.handleMouseEnterChip("SPLIT10")}
                  onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT10'] ? 'flex' : 'none' }}
                   >{this.state.betsMap['SPLIT10'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER2")}
                  onMouseEnter={() => this.handleMouseEnterChip("CORNER2")}
                  onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER2'] ? 'flex' : 'none' }}
                   >{this.state.betsMap['CORNER2'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT4")}
                  onMouseEnter={() => this.handleMouseEnterChip("SPLIT4")}
                  onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT4'] ? 'flex' : 'none' }}
                   >{this.state.betsMap['SPLIT4'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-left" onClick={() => this.handleChipClick("STREET2")}
                  onMouseEnter={() => this.handleMouseEnterChip("STREET2")}
                  onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-left"
                    style={{ display: this.state.betsMap['STREET2'] ? 'flex' : 'none' }}
                   >{this.state.betsMap['STREET2'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-left-center" onClick={() => this.handleChipClick("SPLIT5")}
                  onMouseEnter={() => this.handleMouseEnterChip("SPLIT5")}
                  onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-left-center"
                    style={{ display: this.state.betsMap['SPLIT5'] ? 'flex' : 'none' }}
                   >{this.state.betsMap['SPLIT5'] || ''}
                  </div>
                </div> 

                <div className="chip-big-midle" 
                  onClick={() => this.handleChipClick("SINGLE3")}
                  onMouseEnter={() => this.handleMouseEnterChip("SINGLE3")}
                  onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE3'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE3'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item"> 
                <div className="chip-pos chip-top-center" onClick={() => this.handleChipClick("STREET4")}
                  onMouseEnter={() => this.handleMouseEnterChip("STREET4")}
                  onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-center"
                    style={{ display: this.state.betsMap['STREET4'] ? 'none' : 'none' }}
                  >{this.state.betsMap['STREET4'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-top-right" onClick={() => this.handleChipClick("SIXLINE2")}
                  onMouseEnter={() => this.handleMouseEnterChip("SIXLINE2")}
                  onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-right"
                    style={{ display: this.state.betsMap['SIXLINE2'] ? 'none' : 'none' }}
                  >{this.state.betsMap['SIXLINE2'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT15")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT15")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT15'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT15'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER4")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER4")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER4'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER4'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT9")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT9")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT9'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT9'] || ''}
                  </div>  
                </div> 

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE6")}
                  onMouseEnter={() => this.handleMouseEnterChip("SINGLE6")}
                  onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE6'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE6'] || ''}
                  </div>  
                </div>
              </div>
              <div className="chip-item"> 
                <div className="chip-pos chip-top-center" onClick={() => this.handleChipClick("STREET5")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET5")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-center"
                    style={{ display: this.state.betsMap['STREET5'] ? 'none' : 'none' }}
                  >{this.state.betsMap['STREET5'] || ''}
                  </div> 
                </div>
                <div className="chip-pos chip-top-right" onClick={() => this.handleChipClick("SIXLINE3")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE3")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-right"
                    style={{ display: this.state.betsMap['SIXLINE3'] ? 'none' : 'none' }}
                  >{this.state.betsMap['SIXLINE3'] || ''}
                  </div> 
                </div>
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT20")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT20")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT20'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT20'] || ''}
                  </div> 
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER6")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER6")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER6'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER6'] || ''}
                  </div> 
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT14")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT14")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT14'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT14'] || ''}
                  </div> 
                </div> 

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE9")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE9")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE9'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE9'] || ''}
                  </div> 
                </div>
              </div>
              <div className="chip-item"> 
                <div className="chip-pos chip-top-center" onClick={() => this.handleChipClick("STREET6")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET6")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-center"
                    style={{ display: this.state.betsMap['STREET6'] ? 'none' : 'none' }}
                  >{this.state.betsMap['STREET6'] || ''}
                  </div> 
                </div>
                <div className="chip-pos chip-top-right" onClick={() => this.handleChipClick("SIXLINE4")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE4")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-right"
                    style={{ display: this.state.betsMap['SIXLINE4'] ? 'none' : 'none' }}
                  >{this.state.betsMap['SIXLINE4'] || ''}
                  </div> 
                </div>
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT25")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT25")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT25'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT25'] || ''}
                  </div> 
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER8")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER8")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER8'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER8'] || ''}
                  </div> 
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT19")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT19")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT19'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT19'] || ''}
                  </div> 
                </div> 

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE12")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE12")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE12'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE12'] || ''}
                  </div> 
                </div>
              </div>
              <div className="chip-item"> 
                <div className="chip-pos chip-top-center" onClick={() => this.handleChipClick("STREET7")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET7")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-center"
                    style={{ display: this.state.betsMap['STREET7'] ? 'none' : 'none' }}
                  >{this.state.betsMap['STREET7'] || ''}
                  </div> 
                </div>
                <div className="chip-pos chip-top-right" onClick={() => this.handleChipClick("SIXLINE5")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE5")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-right"
                    style={{ display: this.state.betsMap['SIXLINE5'] ? 'none' : 'none' }}
                  >{this.state.betsMap['SIXLINE5'] || ''}
                  </div> 
                </div>
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT30")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT30")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT30'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT30'] || ''}
                  </div> 
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER10")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER10")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER10'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER10'] || ''}
                  </div> 
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT24")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT24")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT24'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT24'] || ''}
                  </div>   
                </div> 

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE15")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE15")}
                onMouseLeave={this.handleMouseLeaveChip}
                
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE15'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE15'] || ''}
                  </div>  
                </div>
              </div>
              <div className="chip-item"> 
                <div className="chip-pos chip-top-center" onClick={() => this.handleChipClick("STREET8")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET8")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-center"
                    style={{ display: this.state.betsMap['STREET8'] ? 'none' : 'none' }}
                  >{this.state.betsMap['STREET8'] || ''}
                  </div>  
                </div>
                <div className="chip-pos chip-top-right" onClick={() => this.handleChipClick("SIXLINE6")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE6")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-right"
                    style={{ display: this.state.betsMap['SIXLINE6'] ? 'none' : 'none' }}
                  >{this.state.betsMap['SIXLINE6'] || ''}
                  </div>  
                </div>
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT35")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT35")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT35'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT35'] || ''}
                  </div>  
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER12")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER12")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER12'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER12'] || ''}
                  </div>  
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT29")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT29")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT29'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT29'] || ''}
                  </div>  
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE18")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE18")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE18'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE18'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item"> 
                <div className="chip-pos chip-top-center" onClick={() => this.handleChipClick("STREET9")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET9")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-center"
                    style={{ display: this.state.betsMap['STREET9'] ? 'none' : 'none' }}
                  >{this.state.betsMap['STREET9'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-top-right" onClick={() => this.handleChipClick("SIXLINE7")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE7")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-right"
                    style={{ display: this.state.betsMap['SIXLINE7'] ? 'none' : 'none' }}
                  >{this.state.betsMap['SIXLINE7'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT40")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT40")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT40'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT40'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER14")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER14")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER14'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER14'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT34")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT34")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT34'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT34'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE21")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE21")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE21'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE21'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item"> 
                <div className="chip-pos chip-top-center" onClick={() => this.handleChipClick("STREET10")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET10")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-center"
                    style={{ display: this.state.betsMap['STREET10'] ? 'none' : 'none' }}
                  >{this.state.betsMap['STREET10'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-top-right" onClick={() => this.handleChipClick("SIXLINE8")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE8")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-right"
                    style={{ display: this.state.betsMap['SIXLINE8'] ? 'none' : 'none' }}
                  >{this.state.betsMap['SIXLINE8'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT45")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT45")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT45'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT45'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER16")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER16")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER16'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER16'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT39")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT39")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT39'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT39'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE24")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE24")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE24'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE24'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item"> 
                <div className="chip-pos chip-top-center" onClick={() => this.handleChipClick("STREET11")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET11")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-center"
                    style={{ display: this.state.betsMap['STREET11'] ? 'none' : 'none' }}
                  >{this.state.betsMap['STREET11'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-top-right" onClick={() => this.handleChipClick("SIXLINE9")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE9")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-right"
                    style={{ display: this.state.betsMap['SIXLINE9'] ? 'none' : 'none' }}
                  >{this.state.betsMap['SIXLINE9'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT50")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT50")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT50'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT50'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER18")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER18")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER18'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER18'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT44")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT44")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT44'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT44'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE27")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE27")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE27'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE27'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item"> 
                <div className="chip-pos chip-top-center" onClick={() => this.handleChipClick("STREET12")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET12")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-center"
                    style={{ display: this.state.betsMap['STREET12'] ? 'none' : 'none' }}
                  >{this.state.betsMap['STREET12'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-top-right" onClick={() => this.handleChipClick("SIXLINE10")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE10")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-right"
                    style={{ display: this.state.betsMap['SIXLINE10'] ? 'none' : 'none' }}
                  >{this.state.betsMap['SIXLINE10'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT55")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT55")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT55'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT55'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER20")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER20")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER20'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER20'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT49")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT49")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT49'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT49'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE30")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE30")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE30'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE30'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item"> 
                <div className="chip-pos chip-top-center" onClick={() => this.handleChipClick("STREET13")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET13")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-center"
                    style={{ display: this.state.betsMap['STREET13'] ? 'none' : 'none' }}
                  >{this.state.betsMap['STREET13'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-top-right" onClick={() => this.handleChipClick("SIXLINE11")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE11")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-right"
                    style={{ display: this.state.betsMap['SIXLINE11'] ? 'none' : 'none' }}
                  >{this.state.betsMap['SIXLINE11'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT60")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT60")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT60'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT60'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER22")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER22")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER22'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER22'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT54")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT54")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT54'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT54'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE33")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE33")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE33'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE33'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item"> 
                <div className="chip-pos chip-top-center" onClick={() => this.handleChipClick("STREET14")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET14")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-top-center"
                    style={{ display: this.state.betsMap['STREET14'] ? 'none' : 'none' }}
                  >{this.state.betsMap['STREET14'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-top-right" ></div>  
                <div className="chip-pos chip-right-center"></div> 
                 <div className="chip-pos chip-right-bottom"></div>  
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT59")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT59")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT59'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT59'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE36")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE36")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE36'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE36'] || ''}
                  </div>
                </div>
              </div>

              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT8")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT8")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT8'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT8'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER1")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER1")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER1'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER1'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT2")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT2")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT2'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT2'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-left" onClick={() => this.handleChipClick("STREET1")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET1")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['STREET1'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['STREET1'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-left-center" onClick={() => this.handleChipClick("SPLIT3")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT3")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-left-center"
                    style={{ display: this.state.betsMap['SPLIT3'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT3'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE2")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE2")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE2'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE2'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT13")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT13")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT13'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT13'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER3")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER3")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER3'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER3'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT7")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT7")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT7'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT7'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE5")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE5")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE5'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE5'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT18")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT18")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT18'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT18'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER5")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER5")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER5'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER5'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT12")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT12")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT12'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT12'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE8")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE8")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE8'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE8'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT23")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT23")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT23'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT23'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER7")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER7")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER7'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER7'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT17")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT17")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT17'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT17'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE11")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE11")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE11'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE11'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT28")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT28")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT28'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT28'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER9")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER9")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER9'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER9'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT22")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT22")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT22'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT22'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE14")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE14")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE14'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE14'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT33")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT33")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT33'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT33'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER11")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER11")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER11'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER11'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT27")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT27")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT27'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT27'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE17")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE17")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE17'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE17'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT38")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT38")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT38'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT38'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER13")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER13")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER13'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER13'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT32")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT32")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT32'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT32'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE20")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE20")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE20'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE20'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT43")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT43")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT43'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT43'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER15")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER15")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER15'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER15'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT37")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT37")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT37'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT37'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE23")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE23")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE23'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE23'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT48")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT48")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT48'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT48'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER17")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER17")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER17'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER17'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT42")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT42")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT42'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT42'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE26")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE26")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE26'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE26'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT53")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT53")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT53'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT53'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER19")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER19")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER19'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER19'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT47")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT47")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT47'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT47'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE29")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE29")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE29'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE29'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT58")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT58")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT58'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT58'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("CORNER21")}
                onMouseEnter={() => this.handleMouseEnterChip("CORNER21")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['CORNER21'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['CORNER21'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT52")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT52")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT52'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT52'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE32")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE32")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE32'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE32'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center"></div>
                <div className="chip-pos chip-right-bottom"></div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("SPLIT57")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT57")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['SPLIT57'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT57'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE35")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE35")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE35'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE35'] || ''}
                  </div>
                </div>
              </div>

              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT6")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT6")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT6'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT6'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("SIXLINE1")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE1")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['SIXLINE1'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SIXLINE1'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("STREET3")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET3")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['STREET3'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['STREET3'] || ''}</div>
                </div>
                <div className="chip-pos chip-bottom-left" onClick={() => this.handleChipClick("FIRSTFOUR")}
                onMouseEnter={() => this.handleMouseEnterChip("FIRSTFOUR")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-left"
                    style={{ display: this.state.betsMap['FIRSTFOUR'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['FIRSTFOUR'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-left-center" onClick={() => this.handleChipClick("SPLIT1")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT1")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-left-center"
                    style={{ display: this.state.betsMap['SPLIT1'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT1'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE1")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE1")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE1'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE1'] || ''}</div>
                  
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT11")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT11")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT11'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT11'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("SIXLINE2")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE2")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['SIXLINE2'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SIXLINE2'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("STREET4")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET4")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['STREET4'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['STREET4'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE4")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE4")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE4'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE4'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT16")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT16")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT16'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT16'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("SIXLINE3")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE3")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['SIXLINE3'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SIXLINE3'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("STREET5")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET5")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['STREET5'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['STREET5'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE7")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE7")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE7'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE7'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT21")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT21")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT21'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT21'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("SIXLINE4")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE4")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['SIXLINE4'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SIXLINE4'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("STREET6")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET6")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['STREET6'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['STREET6'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE10")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE10")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE10'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE10'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT26")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT26")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT26'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT26'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("SIXLINE5")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE5")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['SIXLINE5'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SIXLINE5'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("STREET7")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET7")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['STREET7'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['STREET7'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE13")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE13")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE13'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE13'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT31")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT31")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT31'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT31'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("SIXLINE6")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE6")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['SIXLINE6'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SIXLINE6'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("STREET8")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET8")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['STREET8'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['STREET8'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE16")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE16")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE16'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE16'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT36")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT36")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT36'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT36'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("SIXLINE7")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE7")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['SIXLINE7'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SIXLINE7'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("STREET9")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET9")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['STREET9'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['STREET9'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE19")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE19")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE19'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE19'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT41")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT41")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT41'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT41'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("SIXLINE8")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE8")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['SIXLINE8'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SIXLINE8'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("STREET10")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET10")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['STREET10'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['STREET10'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE22")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE22")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE22'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE22'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT46")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT46")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT46'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT46'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("SIXLINE9")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE9")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['SIXLINE9'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SIXLINE9'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("STREET11")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET11")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['STREET11'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['STREET11'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE25")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE25")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE25'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE25'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT51")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT51")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT51'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT51'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("SIXLINE10")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE10")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['SIXLINE10'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SIXLINE10'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("STREET12")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET12")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['STREET12'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['STREET12'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE28")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE28")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE28'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE28'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center" onClick={() => this.handleChipClick("SPLIT56")}
                onMouseEnter={() => this.handleMouseEnterChip("SPLIT56")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-center"
                    style={{ display: this.state.betsMap['SPLIT56'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SPLIT56'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-right-bottom" onClick={() => this.handleChipClick("SIXLINE11")}
                onMouseEnter={() => this.handleMouseEnterChip("SIXLINE11")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-right-bottom"
                    style={{ display: this.state.betsMap['SIXLINE11'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SIXLINE11'] || ''}
                  </div>
                </div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("STREET13")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET13")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['STREET13'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['STREET13'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE31")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE31")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE31'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE31'] || ''}
                  </div>
                </div>
              </div>
              <div className="chip-item">  
                <div className="chip-pos chip-right-center"></div>
                <div className="chip-pos chip-right-bottom"></div>
                <div className="chip-pos chip-bottom-center" onClick={() => this.handleChipClick("STREET14")}
                onMouseEnter={() => this.handleMouseEnterChip("STREET14")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number chip-number-bottom-center"
                    style={{ display: this.state.betsMap['STREET14'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['STREET14'] || ''}
                  </div>
                </div>

                <div className="chip-big-midle" onClick={() => this.handleChipClick("SINGLE34")}
                onMouseEnter={() => this.handleMouseEnterChip("SINGLE34")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="chip-number"
                    style={{ display: this.state.betsMap['SINGLE34'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SINGLE34'] || ''}
                  </div>
                </div>
              </div>
            </div>

          {/* Top row – Zero Spiel, Orphelins, Voisins (above the number grid) */}
            <ul className="d-flex list-unstyled top-dozen-row">
              <button className="bottom-big blues cella-fourth chip-container-cella-fourth top-top_border-left"
                onClick={() => this.handleChipClick("ZEROSPIEL")}
                onMouseEnter={() => this.handleMouseEnterChip("ZEROSPIEL")}
                onMouseLeave={this.handleMouseLeaveChip}
              >
                <div className="chip-stav">Zero Spiel</div>
                <div className="chip-number chipt-number-dozen"
                  style={{ display: this.state.betsMap['ZEROSPIEL'] ? 'flex' : 'none' }}
                >{this.state.betsMap['ZEROSPIEL'] || ''}</div>
              </button>
              <button className="bottom-big blues cella-fourth chip-container-cella-fourth"
                onClick={() => this.handleChipClick("ORPHELINS")}
                onMouseEnter={() => this.handleMouseEnterChip("ORPHELINS")}
                onMouseLeave={this.handleMouseLeaveChip}
              >
                <div className="chip-stav">Orphelins</div>
                <div className="chip-number chipt-number-dozen"
                  style={{ display: this.state.betsMap['ORPHELINS'] ? 'flex' : 'none' }}
                >{this.state.betsMap['ORPHELINS'] || ''}</div>
              </button>
              <button className="bottom-big blues cella-fourth chip-container-cella-fourth top-top_border-right"
                onClick={() => this.handleChipClick("VOISINS")}
                onMouseEnter={() => this.handleMouseEnterChip("VOISINS")}
                onMouseLeave={this.handleMouseLeaveChip}
              >
                <div className="chip-stav">Voisins</div>
                <div className="chip-number chipt-number-dozen"
                  style={{ display: this.state.betsMap['VOISINS'] ? 'flex' : 'none' }}
                >{this.state.betsMap['VOISINS'] || ''}</div>
              </button>
            </ul>

            {/* First row */}
            <ul className="d-flex list-unstyled">
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('3') ? 'hovered-class' : ''}`} value="3">
                <div>3</div>
              </button>
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('6') ? 'hovered-class' : ''}`} value="6">
                <div>6</div>
              </button>
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('9') ? 'hovered-class' : ''}`} value="9">
                <div>9</div>
              </button>
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('12') ? 'hovered-class' : ''}`} value="12">
                <div>12</div>
              </button>
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('15') ? 'hovered-class' : ''}`} value="15">
                <div>15</div>
              </button>
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('18') ? 'hovered-class' : ''}`} value="18">
                <div>18</div>
              </button>
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('21') ? 'hovered-class' : ''}`} value="21">
                <div>21</div>
              </button>
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('24') ? 'hovered-class' : ''}`} value="24">
                <div>24</div>
              </button>
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('27') ? 'hovered-class' : ''}`} value="27">
                <div>27</div>
              </button>
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('30') ? 'hovered-class' : ''}`} value="30">
                <div>30</div>
              </button>
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('33') ? 'hovered-class' : ''}`} value="33">
                <div>33</div>
              </button>
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('36') ? 'hovered-class' : ''}`} value="36">
                <div>36</div>
              </button>
            </ul>

 

            {/* Second row */}
            <ul className="d-flex list-unstyled">
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('2') ? 'hovered-class' : ''}`} value="2">
                <div>2</div>
              </button>
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('5') ? 'hovered-class' : ''}`} value="5">
                <div>5</div>
              </button>
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('8') ? 'hovered-class' : ''}`} value="8">
                <div>8</div>
              </button>
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('11') ? 'hovered-class' : ''}`} value="11">
                <div>11</div>
              </button>
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('14') ? 'hovered-class' : ''}`} value="14">
                <div>14</div>
              </button>
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('17') ? 'hovered-class' : ''}`} value="17">
                <div>17</div>
              </button>
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('20') ? 'hovered-class' : ''}`} value="20">
                <div>20</div>
              </button>
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('23') ? 'hovered-class' : ''}`} value="23">
                <div>23</div>
              </button>
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('26') ? 'hovered-class' : ''}`} value="26">
                <div>26</div>
              </button>
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('29') ? 'hovered-class' : ''}`} value="29">
                <div>29</div>
              </button>
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('32') ? 'hovered-class' : ''}`} value="32">
                <div>32</div>
              </button>
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('35') ? 'hovered-class' : ''}`} value="35">
                <div>35</div>
              </button>
            </ul>

 

            {/* Third row */}
            <ul className="d-flex list-unstyled">
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('1') ? 'hovered-class' : ''}`} value="1">
                <div>1</div>
              </button>
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('4') ? 'hovered-class' : ''}`} value="4">
                <div>4</div>
              </button>
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('7') ? 'hovered-class' : ''}`} value="7">
                <div>7</div>
              </button>
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('10') ? 'hovered-class' : ''}`} value="10">
                <div>10</div>
              </button>
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('13') ? 'hovered-class' : ''}`} value="13">
                <div>13</div>
              </button>
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('16') ? 'hovered-class' : ''}`} value="16">
                <div>16</div>
              </button>
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('19') ? 'hovered-class' : ''}`} value="19">
                <div>19</div>
              </button>
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('22') ? 'hovered-class' : ''}`} value="22">
                <div>22</div>
              </button>
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('25') ? 'hovered-class' : ''}`} value="25">
                <div>25</div>
              </button>
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('28') ? 'hovered-class' : ''}`} value="28">
                <div>28</div>
              </button>
              <button className={`cal-tab black cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('31') ? 'hovered-class' : ''}`} value="31">
                <div>31</div>
              </button>
              <button className={`cal-tab red cella chip-container-cella border-bottom border-right border-left
                ${this.state.hoveredValue.split(/[,\s-]+/).includes('34') ? 'hovered-class' : ''}`} value="34">
                <div>34</div>
              </button>
            </ul>

 

            </div>

            {/* Fourth row */}
            <ul className="d-flex list-unstyled">
              <button className="bottom-big blues cella-fourth chip-container-cella-fourth bottom-bottom_border-left"   onClick={() => this.handleChipClick("DOZEN1")}
              onMouseEnter={() => this.handleMouseEnterChip("DOZEN1")}
              onMouseLeave={this.handleMouseLeaveChip}
              >
                <div className="chip-stav">1st 12</div>
                <div className="chip-number chipt-number-dozen"
                      style={{ display: this.state.betsMap['DOZEN1'] ? 'flex' : 'none' }}
                    >{this.state.betsMap['DOZEN1'] || ''}
                  </div>
              </button>
              <button className="bottom-big blues cella-fourth chip-container-cella-fourth "  onClick={() => this.handleChipClick("DOZEN2")}
              onMouseEnter={() => this.handleMouseEnterChip("DOZEN2")}
              onMouseLeave={this.handleMouseLeaveChip}
              >
                <div className="chip-stav">2nd 12</div>
                <div className="chip-number chipt-number-dozen"
                      style={{ display: this.state.betsMap['DOZEN2'] ? 'flex' : 'none' }}
                    >{this.state.betsMap['DOZEN2'] || ''}
                  </div>
              </button>
              <button className="bottom-big blues cella-fourth chip-container-cella-fourth bottom-bottom_border-right"  onClick={() => this.handleChipClick("DOZEN3")}
              onMouseEnter={() => this.handleMouseEnterChip("DOZEN3")}
              onMouseLeave={this.handleMouseLeaveChip}
              >
                <div className="chip-stav">3rd 12</div>
                <div className="chip-number chipt-number-dozen"
                      style={{ display: this.state.betsMap['DOZEN3'] ? 'flex' : 'none' }}
                    >{this.state.betsMap['DOZEN3'] || ''}
                  </div>
                </button>
            </ul>

            
 

            {/* Fifth row */}
            <ul className="d-flex list-unstyled">
              <button className="bottom-bottom blues cella-fifth chip-container-cella-fifth bottom-bottom_border-left" onClick={() => this.handleChipClick("LOW")}
              onMouseEnter={() => this.handleMouseEnterChip("LOW")}
              onMouseLeave={this.handleMouseLeaveChip}
              >
                <div className="bottom-bottom__block">1 to 18</div>
                <div className="chip-number chipt-number-dozen"
                      style={{ display: this.state.betsMap['LOW'] ? 'flex' : 'none' }}
                    >{this.state.betsMap['LOW'] || ''}
                  </div>
              </button>
              <button className="uppercase bottom-bottom blues cella-fifth chip-container-cella-fifth " onClick={() => this.handleChipClick("EVEN")}
              onMouseEnter={() => this.handleMouseEnterChip("EVEN")}
              onMouseLeave={this.handleMouseLeaveChip}
              >
                <div className="bottom-bottom__block">Even</div>
                <div className="chip-number chipt-number-dozen"
                      style={{ display: this.state.betsMap['EVEN'] ? 'flex' : 'none' }}
                    >{this.state.betsMap['EVEN'] || ''}
                  </div>
              </button>
              <button className="romb romb-red bottom-bottom reds cella-fifth chip-container-cella-fifth " onClick={() => this.handleChipClick("RED")}
              onMouseEnter={() => this.handleMouseEnterChip("RED")}
              onMouseLeave={this.handleMouseLeaveChip}
              >
                <div className="bottom-bottom__block">
                  <div className="blo"></div>
                </div>
                
                <div className="chip-number chipt-number-dozen"
                      style={{ display: this.state.betsMap['RED'] ? 'flex' : 'none' }}
                    >{this.state.betsMap['RED'] || ''}
                  </div>
                </button>
              <button className="romb romb-black bottom-bottom blacks cella-fifth chip-container-cella-fifth " onClick={() => this.handleChipClick("BLACK")}
              onMouseEnter={() => this.handleMouseEnterChip("BLACK")}
              onMouseLeave={this.handleMouseLeaveChip}
              >
                <div className="bottom-bottom__block">
                  <div className="blo"></div>
                </div>
                <div className="chip-number chipt-number-dozen"
                      style={{ display: this.state.betsMap['BLACK'] ? 'flex' : 'none' }}
                    >{this.state.betsMap['BLACK'] || ''}
                  </div>
              </button>
              <button className="uppercase bottom-bottom blues cella-fifth chip-container-cella-fifth " onClick={() => this.handleChipClick("ODD")}
              onMouseEnter={() => this.handleMouseEnterChip("ODD")}
              onMouseLeave={this.handleMouseLeaveChip}
              >
                <div className="bottom-bottom__block">Odd</div>
                <div className="chip-number chipt-number-dozen"
                      style={{ display: this.state.betsMap['ODD'] ? 'flex' : 'none' }}
                    >{this.state.betsMap['ODD'] || ''}
                  </div>
              </button>
              <button className="bottom-bottom blues cella-fifth chip-container-cella-fifth bottom-bottom_border-right" onClick={() => this.handleChipClick("HIGH")}
              onMouseEnter={() => this.handleMouseEnterChip("HIGH")}
              onMouseLeave={this.handleMouseLeaveChip}
              >
                <div className="bottom-bottom__block">19 to 36</div>
                <div className="chip-number chipt-number-dozen"
                      style={{ display: this.state.betsMap['HIGH'] ? 'flex' : 'none' }}
                    >{this.state.betsMap['HIGH'] || ''}
                  </div>
              </button>
            </ul>
          </div>

 

          <div className="align-self-start"> 
            <ul className="list-unstyled">
              <li className="right-block shake-block-custom blues cella chip-container-cella border-bottom-none">
                <button className="blues" onClick={() => this.handleChipClick("SNAKE")}
                  onMouseEnter={() => this.handleMouseEnterChip("SNAKE")}
                  onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div>Snake</div>
                  <div className="chip-number chipt-number-right"
                    style={{ display: this.state.betsMap['SNAKE'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['SNAKE'] || ''}</div>
                </button>
              </li>
              <li className="right-block blues cella chip-container-cella border-bottom-top-none">
                <button className="blues " value="2to 1" onClick={() => this.handleChipClick("COLUMN3")}
                onMouseEnter={() => this.handleMouseEnterChip("COLUMN3")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div>C3</div>
                  <div className="chip-number chipt-number-right"
                      style={{ display: this.state.betsMap['COLUMN3'] ? 'flex' : 'none' }}
                    >{this.state.betsMap['COLUMN3'] || ''}
                  </div>
                </button>
              </li>
   
              <li className="right-block blues cella chip-container-cella border-bottom-top-none">
                <button className="blues " value="2to 1" onClick={() => this.handleChipClick("COLUMN2")}
                onMouseEnter={() => this.handleMouseEnterChip("COLUMN2")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div>C2</div>
                  <div className="chip-number chipt-number-right"
                      style={{ display: this.state.betsMap['COLUMN2'] ? 'flex' : 'none' }}
                    >{this.state.betsMap['COLUMN2'] || ''}
                  </div>
                </button>
              </li>
 
              <li className="right-block blues cella chip-container-cella border-top-none">
                <button className="blues " value="2to 1" onClick={() => this.handleChipClick("COLUMN1")}
                onMouseEnter={() => this.handleMouseEnterChip("COLUMN1")}
                onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div>C1</div>
                  <div className="chip-number chipt-number-right"
                      style={{ display: this.state.betsMap['COLUMN1'] ? 'flex' : 'none' }}
                    >{this.state.betsMap['COLUMN1'] || ''}
                  </div>
                </button>
              </li>
              <li className="right-block blk-split-block blacks cella chip-container-cella border-top-none">
                <button className="blacks" onClick={() => this.handleChipClick("BLACKSPLIT")}
                  onMouseEnter={() => this.handleMouseEnterChip("BLACKSPLIT")}
                  onMouseLeave={this.handleMouseLeaveChip}
                >
                  <div className="red-blck-split-txt">black split</div>
                  <div className="chip-number chipt-number-right"
                    style={{ display: this.state.betsMap['BLACKSPLIT'] ? 'flex' : 'none' }}
                  >{this.state.betsMap['BLACKSPLIT'] || ''}</div>
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* <div className="betsOfNew">
            <div className="betsOf__title">BETS {this.state.betsInfoTxt}</div>
        </div> */}

        {/* <div className="top-info">
            
          <div className="info-right">
   
            <div className="btn-stav-item">
              <button
                className={`btn-stav btn-chipt btn-chipt-yellow ${this.state.betDenomination === 1 ? 'active' : ''}`}
                onClick={() => this.onSetDenomination(1)}
              >
                1
              </button>
            </div>
            <div className="btn-stav-item">
              <button
                className={`btn-stav btn-chipt btn-chipt-blue ${this.state.betDenomination === 5 ? 'active' : ''}`}
                onClick={() => this.onSetDenomination(5)}
              >
                5
              </button>
            </div>
            <div className="btn-stav-item">
              <button
                className={`btn-stav btn-chipt btn-chipt-green ${this.state.betDenomination === 10 ? 'active' : ''}`}
                onClick={() => this.onSetDenomination(10)}
              >
                10
              </button>
            </div>
            <div className="btn-stav-item">
              <button
                className={`btn-stav btn-chipt btn-chipt-purple ${this.state.betDenomination === 20 ? 'active' : ''}`}
                onClick={() => this.onSetDenomination(20)}
              >
                20
              </button>
            </div>
            <div className="btn-stav-item">
              <button
                className={`btn-stav btn-chipt  btn-chipt-black ${this.state.betDenomination === 50 ? 'active' : ''}`}
                onClick={() => this.onSetDenomination(50)}
              >
                50
              </button>
            </div>
            <div className="btn-stav-item">
              <button
                className={`btn-stav btn-chipt btn-chipt-orange ${this.state.betDenomination === 100 ? 'active' : ''}`}
                onClick={() => this.onSetDenomination(100)}
              >
                100
              </button>
            </div>
          </div>

          <div className="info-total">
            <span className="info-total-text">TOTAL:</span>
            <span className="info-total-number">${this.state.betsTotal}</span>
          </div>
        </div> */}


      </React.Fragment>

              

    );
  }
}

export default RouletteTable;
